module.exports = __webpack_public_path__ + "static/img/1_1_2_1.f3163a96.jpg";